module.exports = __webpack_public_path__ + "img/icon-tick-co.042d5105.png";